import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import AsyncContent from '../../components/AsyncContent';
import SelectTypeField from '../../components/SelectTypeField';

class PatientSearchForm extends React.PureComponent {
  render() {
    const {
      handleSubmit,
      isSubmitting,
      onSearchTypeChange,
      searchFieldComponent,
      styles,
      selectedSearchType,
      selectedOptionValues,
    } = this.props;

    let selectedOptionValue = '1';
    if (selectedSearchType) {
      selectedOptionValue = selectedSearchType;
    }
    return (
      <form onSubmit={handleSubmit}>
        <div className={styles.searchFields}>
          <div className={styles.searchType}>
            <Field
              component={SelectTypeField}
              name="searchType"
              className="searchTypeSelect react-select-filter-selector"
              selectedValue={selectedOptionValue}
              options={selectedOptionValues}
              onSelect={onSearchTypeChange}
              isSearchable={false}
            />
          </div>
          {searchFieldComponent}
          <button
            className={styles.submitButton}
            type="submit"
            disabled={isSubmitting}
          >
            <AsyncContent isFetching={isSubmitting}>
              <FormattedMessage id="search.SearchForm.Button.Submit" />
            </AsyncContent>
          </button>
        </div>
      </form>
    );
  }
}

PatientSearchForm.contextType = UserProfileContext;
export default reduxForm({
  form: 'workListPatientSearchForm',
  onChange(values, dispatch, props, previousValues) {
    if (props.onFormChange) props.onFormChange(values, previousValues);
  },
})(PatientSearchForm);



// WEBPACK FOOTER //
// ./src/views/containers/WorkListSearch/PatientSearchForm.jsx